import React from 'react';

interface SelectableOptionProps {
	icon: string;
	iconAlt?: string;
	text: string;
	isSelected?: boolean;
	onClick?: () => void;
	rightIcon?: string;
	customClass?: string;
	iconSize?: string;
	rightIconBg?: string;
	textSize?: string;
	disabled?: boolean;
}

const SelectableOption: React.FC<SelectableOptionProps> = ({
	icon,
	iconAlt = '',
	text,
	isSelected = false,
	onClick,
	rightIcon,
	customClass = '',
	iconSize = 'w-[16px] h-[16px]',
	rightIconBg = 'bg-[#00E0FF]',
	textSize = 'text-[12px]',
	disabled = false,
}) => {
	const handleClick = () => {
		if (!disabled && onClick) {
			onClick();
		}
	};

	return (
		<div
			className={`h-[56px] w-full rounded-[20px] bg-[#0084FF1A] p-3 flex items-center justify-between ${
				isSelected 
					? 'border-[2px] border-[#00E0FF]' 
					: 'border-[1px] border-[#FFFFFF1A]'
			} ${customClass}`}
			onClick={handleClick}
		>
			<div className="flex items-center gap-2">
				<img src={icon} alt={iconAlt} className={iconSize} />
				<span className={`${textSize} text-white font-semibold`}>
					{text}
				</span>
			</div>
			{rightIcon && (
				<div className={`w-[16px] h-[16px] rounded-full flex items-center justify-center ${!isSelected && "opacity-10"}  ${rightIconBg}`}>
					<img src={rightIcon} alt="selection indicator" />
				</div>
			)}
		</div>
	);
};

export default SelectableOption; 